import React, { useState } from "react";

const SubscriptionManager = ({ onBack }) => {
  const [selectedPlan, setSelectedPlan] = useState("Yearly");

  const handleSelect = (plan) => {
    setSelectedPlan(plan);
  };

  return (
    <div className="min-h-screen">

      <div className="w-full flex items-center" style={{
            background: "linear-gradient(to bottom, rgba(225, 225, 225, 1) 0%, rgba(225, 225, 225, 0) 100%)",
            padding: "35px 21px 26px"
      }}>
        {/* Back Button */}
        <button
          onClick={onBack}
          className=" absolute top-[34px] bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        {/* Title */}
        <h1 className="text-[20px] leading-[20px] text-[#1E0A1E] font-normal font-young-serif text-center mx-auto">
          Manage Subscription
        </h1>
      </div>

      {/* Content Container */}
      <div className=" p-6 pt-0">
        <div className="mb-8">
        <div className="mx-1 border-t border-[#EEEEEE]" />
          <h2 className="text-[20px] pl-[24px] font-normal text-[#1D1726] mb-4 font-young-serif  pt-3">
            Current plan
          </h2>
          <div
            onClick={() => handleSelect("Yearly")}
            className={`cursor-pointer rounded-3xl p-6 ${
              selectedPlan === "Yearly"
                ? "bg-black text-white shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
                : "border-2 border-gray-200 bg-transparent text-black"
            }`}
          >
            <div className="flex justify-between items-center w-full">
              <div className="text-[30px] font-young-serif font-normal">Yearly</div>
              <div className="flex items-baseline">
                <span className={`text-[30px] learning-[38px] font-bold font-space-grotesk ${
                  selectedPlan === "Yearly" ? "text-white" : "text-[#1E0A1E]"
                }`}>€7.49</span>
                <span className={`text-[12px] font-medium font-space-grotesk ${
                  selectedPlan === "Yearly" ? "text-white" : "text-[#1E0A1E]"
                }`}>/mo</span>
              </div>
            </div>
            <p className="text-[12px] text-right font-space-grotesk">
              <span className={selectedPlan === "Yearly" ? "text-gray-400" : "text-[#929292]"}>
                £119.88
              </span>{" "}
              Billed annually
            </p>
          </div>
        </div>
        <div className="mb-8">
          <h2 className="text-[20px] pl-[24px] font-normal text-[#1D1726] mb-4 font-young-serif">
            Switch to
          </h2>
          <div
            onClick={() => handleSelect("Monthly")}
            className={`cursor-pointer rounded-3xl p-6 ${
              selectedPlan === "Monthly"
                ? "bg-black text-white shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
                : "border-2 border-gray-200 bg-transparent text-black"
            }`}
          >
            <div className="flex justify-between items-center w-full">
              <div className="text-[30px] font-young-serif font-normal pr-2">Monthly</div>
              <div className="flex items-baseline">
                <span className="text-[30px] font-bold font-space-grotesk">€12.99</span>
                <span className="text-[12px] font-space-grotesk">/mo</span>
              </div>
            </div>
            <p className="text-[12px] text-right font-space-grotesk">
              <span className={selectedPlan === "Monthly" ? "text-gray-400" : "text-[#929292]"}>
                 €14.99
              </span>
            </p>
          </div>
        </div>

        <div className="flex justify-center mt-6 mb-8">
          <button className="bg-[#1E0A1E] text-[#EEEEEE] font-space-grotesk text-[16px] font-medium py-2 px-6 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
            Save
          </button>
        </div>

        <div className="text-center text-[#1E0A1E] text-[14px] font-medium font-space-grotesk">
          <a href="#" className=" underline">
            Manage my subscription & billing
          </a>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionManager;